import { createSlice } from "@reduxjs/toolkit";

export const mediaListSlice = createSlice({
  name: 'mediaList',
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startMediaList: (state) => { state.isLoading = true; },
    setMediaList: (state, { payload: { data = null, error = null}}) => {
      state.data = data;
      state.error = error;
      state.isLoading = false;
    }
  }
});

export const { startMediaList, setMediaList } = mediaListSlice.actions;

export default mediaListSlice;
